export default args => Math.min(...args);
